import { render, staticRenderFns } from "./CustomOverlay.vue?vue&type=template&id=3ed8f5c8&scoped=true&"
import script from "./CustomOverlay.vue?vue&type=script&lang=js&"
export * from "./CustomOverlay.vue?vue&type=script&lang=js&"
import style0 from "./CustomOverlay.vue?vue&type=style&index=0&id=3ed8f5c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed8f5c8",
  null
  
)

export default component.exports